<template>
  <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
    <FormItem label="输入密码" prop="passwd">
      <Input type="password" v-model="formCustom.passwd" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem label="确认密码" prop="passwdCheck">
      <Input type="password" v-model="formCustom.passwdCheck" @on-change="showtips=false"></Input>
    </FormItem>
    <FormItem>
 <!--      <Alert type="warning" show-icon :style="{display: showtips?'block':'none'}">
        <span slot="desc">您所提交的信息有误,请重新输入 </span>
      </Alert> -->
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: 'GetPwdSubmit',
  data() {

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formCustom.passwdCheck !== '') {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField('passwdCheck');
        }
        callback();
      }
    }
    const validatePassCheck = (rule, value, callback) => {

      if (value.length < 6) {
        callback(new Error(this.pwdrule));
      }

      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value !== this.formCustom.passwd) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    }
    return {
      formCustom: {
        passwd: '',
        passwdCheck: '',
      },
      ruleCustom: {
        passwd: [
          { validator: validatePass, trigger: 'blur' }
        ],
        passwdCheck: [
          { validator: validatePassCheck, trigger: 'blur' }
        ],
      },
      showtips: false,
      pwdrule: '密码长度至少6位',
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.showtips = false;
           this.$emit('pwdSubmitok',this.formCustom.passwd);
          //this.$Message.success('密码重置成功!');
          //ajax 成功则关闭,并跳转至登录
          //console.log(this.formCustom);
        } else {
          //this.$Message.error('Fail!');
          this.showtips = true;
        }
      })
    },
    handleReset(name) {
      //console.log(22222)
      this.$refs[name].resetFields();
      this.showtips = false;
    },
  }
}
</script>
<style>
</style>
